import i18next from 'i18next';
import { AsYouType, type CountryCode, isSupportedCountry } from 'libphonenumber-js/max';
import type { RefinementCtx } from 'zod';

export function parseAndValidatePhone(
  value: string,
  ctx: RefinementCtx,
  countries?: CountryCode[],
): string | null {
  if (countries?.some(c => !isSupportedCountry(c.toUpperCase()))) {
    throw new Error('Unsupported country code provided.');
  }

  let unsupportedCountryProvided = false;

  const countriesToTry: (CountryCode | undefined)[] = !countries?.length
    ? [undefined, 'FR']
    : countries;

  for (const country of countriesToTry) {
    const formatter = new AsYouType(country);
    formatter.input(value);

    if (!formatter.isValid()) continue;

    const parsed = formatter.getNumber();

    if (countries?.length && (!parsed?.country || !countries.includes(parsed?.country))) {
      unsupportedCountryProvided = true;
      continue;
    }

    return formatter.getNumberValue() ?? null;
  }

  ctx.addIssue({
    code: 'custom',
    message: i18next.t(
      unsupportedCountryProvided ? 'formErrors.phoneInvalidCountry' : 'formErrors.phoneInvalid',
    ),
    fatal: true,
  });

  return null;
}
